export type InsertFn = (handlebar: string) => void;

export enum FieldSearchOption {
  UserProfile = 'User Profile',
  Event = 'Event',
}

export enum DCB_MODAL {
  Confirmation = 'confirmation',
}

export enum ContentType {
  html = 'html',
  plaintext = 'plaintext',
}
